import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

import { DateRange } from '../api/models/date-range';

@Pipe({
    name: 'dateRange',
    pure: true
})
export class DateRangePipe implements PipeTransform {

  constructor(private datePipe: DatePipe) {}

  transform(value: DateRange, format: string): string {
    const from = this.datePipe.transform(value.from, format);
    const to = this.datePipe.transform(value.to, format);
    return `${from || ''} - ${to || ''}`;
  }
}
